import { Text } from '@fluentui/react';

const buildId = process.env.REACT_APP_BUILD_ID;
const buildBranch = process.env.REACT_APP_BUILD_BRANCH;

const PwBuildBadge = () => {
  if (!buildId && !buildBranch) return null;

  const label = [buildBranch, buildId ? `#${buildId}` : null].filter(Boolean).join(' · ');

  return (
    <div style={{ textAlign: 'center', marginTop: '24px' }}>
      <Text variant="tiny" style={{ color: '#a19f9d' }}>{label}</Text>
    </div>
  );
};

export default PwBuildBadge;
